import type { ReactNode } from "react";
import { ArrowLeft, Check } from "lucide-react";
import "../../styles/payment-design.css";
import "../../styles/payment-flow-mobile.css";

export default function PaymentStepFrame({
  phase = 1, step, steps, progress, title, description, onBack, children, busy = false,
}: {
  phase?: 1 | 2;
  step: number;
  steps: string[];
  progress?: { step: number; steps: string[] };
  title: string;
  description?: string;
  onBack: () => void;
  children: ReactNode;
  busy?: boolean;
}) {
  const progressStep = progress?.step ?? step;
  const progressSteps = progress?.steps ?? steps;
  return (
    <div className="jp-payment-layout jp-flow-frame">
      <aside className="jp-payment-aside">
        <span className="jp-payment-eyebrow">주류대금 카드결제</span>
        <h2>주류대금도,<br />결제는 <em>더 여유롭게.</em></h2>
        <ol className="jp-payment-journey" aria-label="입력 순서">
          {progressSteps.map((label, index) => (
            <li key={label} className={index + 1 < progressStep ? "is-done" : index + 1 === progressStep ? "is-current" : ""} aria-current={index + 1 === progressStep ? "step" : undefined}>
              <span className="jp-payment-journey-icon">{index + 1 < progressStep ? <Check size={15} /> : `0${index + 1}`}</span>
              <div>{label}{index + 1 === progressStep && <small>진행 중</small>}</div>
            </li>
          ))}
        </ol>
      </aside>

      <section className="jp-payment-card" aria-label={title}>
        <div className="jp-payment-card-top">
          <button type="button" onClick={onBack} disabled={busy} className="jp-payment-back" aria-label="이전 단계"><ArrowLeft size={21} /></button>
          <strong>{phase === 2 ? "송금 정보" : "결제 요청"}</strong>
          <span className="jp-payment-step-count" aria-hidden="true">{progressStep} / {progressSteps.length}</span>
        </div>
        <ol className="jp-payment-steps" aria-label={`${progressSteps.length}단계 중 ${progressStep}단계: ${progressSteps[progressStep - 1]}`}>
          {progressSteps.map((label, index) => (
            <li key={label} className={index + 1 < progressStep ? "is-done" : index + 1 === progressStep ? "is-current" : ""} aria-current={index + 1 === progressStep ? "step" : undefined}>
              <span>{label}</span>
            </li>
          ))}
        </ol>
        <div className="jp-payment-card-heading">
          <h1>{title}</h1>
          {description && <p>{description}</p>}
        </div>
        <div className="jp-payment-fields">{children}</div>
      </section>
    </div>
  );
}
